"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateOfficeSiteApiResponseSchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
exports.updateOfficeSiteApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        type: (0, api_1.apiEntityTypeSchema)('offices'),
        attributes: zod_1.z.object({
            siteId: zod_1.z.string().uuid(),
            updatedAt: zod_1.z.coerce.date(),
        }),
    }),
});
